// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "organization_service_form_requirement".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "organization_service_form_requirement" table (1:1 with a DB row, on the wire). */
export const organizationServiceFormRequirementAtomSchema = z.object({
    id: z.string(),
    serviceId: z.string(),
    templateId: z.string(),
    createdAt: z.string().datetime(),
});
//# sourceMappingURL=organizationServiceFormRequirement.js.map